import { render, staticRenderFns } from "./caveInf.vue?vue&type=template&id=96fc697e"
import script from "./caveInf.vue?vue&type=script&lang=js"
export * from "./caveInf.vue?vue&type=script&lang=js"
import style0 from "./caveInf.vue?vue&type=style&index=0&id=96fc697e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports